<style>
  @import "https://cdn.boldreports.com/2.2.32/content/material/bold.reports.all.min.css";
</style>
<template>

  <div ref="reportsPage">
    <div class="w-full">
      <vx-card class="mb-5" id="reportsCard" ref="reports" title="Reports" v-show="isInfoHidden">
          <div class="credentials mb-3">
            <h5>When promted for credentials use</h5>
            <div class="vx-row">
              <div class="vx-col">
                <p>Username: ReportUser</p>
                <p>Password: Reporting99!</p>
                <p id="CopyText" hidden>ReportUser,Reporting99!</p>
              </div>
              <div class="vx-col coppyButton">
                <vs-button @click="copy" >Copy</vs-button>
              </div>
            </div>
          </div>
        <vs-table :sst="true" @search="handleSearch" @change-page="handleChangePage" stripe ref="reportsTable" class="vs-con-loading__container" single @selected="handleSelectedReport" pagination :max-items="pageSize" search :data="reports">
          <!-- @sort="handleSort" -->
          <div v-if="$acl.check('Monitor')" slot="header" class="flex flex-wrap-reverse items-center flex-grow">
            <vs-dropdown ref="companyListDropDown" vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span
              class="mr-2"
            >{{selectedCompanyName.length ? selectedCompanyName : 'Select a Company'}}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item v-for="(company,companyIndx) in companyList" :key="companyIndx" @click="selectedCompany(company)">
              <span>{{company.text}}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
            <!-- ADD NEW -->
            <!--<div ref="addNew" class="p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewReport">
      <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
      <span class="ml-2 text-base text-primary">Add New</span>
    </div>-->
          </div>

          <template slot="thead">
            <vs-th>Name</vs-th>
            <vs-th>Description</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="report" :key="indextr" v-for="(report, indextr) in data">

              <vs-td :data="data[indextr].name">
                {{ report.displayName }}
              </vs-td>

              <vs-td :data="data[indextr].description">
                {{ report.description }}
              </vs-td>


              <!--<vs-td>
                <vs-button size="small" :color="'primary'" >View Report</vs-button>
              </vs-td>-->
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>

    <div>
      <vx-card height="70vh" id="reportViewerCard" class="vs-con-loading__container" ref="reportInfo" v-show="!isInfoHidden">
        <!-- Creating a div tag which will act as a container for boldReportViewer widget.-->

        <vs-divider class="mb-6 pt-0"></vs-divider>
        <div class="vx-row">
          <vs-spacer></vs-spacer>
          <div class="vx-col">
            <vs-button color="warning" type="border" class="mb-2" v-scroll-to="'#reportInfoCard'" @click="cancelReportViewer">Close</vs-button>
          </div>
        </div>
      </vx-card>

    </div>

  </div>
</template>

<script>
  //import '../../assets/css/bold.reports.all.min.css'

  import jQuery from './jquery';
  import boldReportsCommon from './common/bold.reports.common.min.js';
  import boldReportsWidgets from './common/bold.reports.widgets.min.js';

  //These js can be imported if reports contains visual elements  
  //import ejChart from './data-visualization/ej.chart.min.js';
  //import ejBase from './common/ej2-base.min.js';
  //import ejData from './common/ej2-data.min.js';
  //import ejPdfExport from './common/ej2-pdf-export.min.js';
  //import sjSvgBase from './common/ej2-svg-base.min.js';
  //import ejLinear from './data-visualization/ej2-lineargauge.min.js';
  //import ejCircular from './data-visualization/ej2-circulargauge.min.js';
  //import ejMap from './data-visualization/ej.map.min.js';

  import boldReportViewer from './bold.report-viewer.min.js';

  import vSelect from 'vue-select';
  export default {
    components: {
      'v-select': vSelect
    },
    data() {
      return {
        pageSize: 10,
        reports: [],
        documentUrl:"",
        criteria: {
          pageSize: 0,
          pageNumber: 0,
          sortKey: "",
          sortOrder: "",
          searchPhrase: "",
          showInactive: false
        },
        isInfoHidden: true,
        currentSiteId: 0,
        selectedCompanyId:0,
        selectedCompanyName:"",
        companyList:[],
      }
    },
    watch: {

    },
    methods: {
      addNewReport() {
        //TODO
      },
      handleSearch(searchPhrase) {
        var self = this;

        if (searchPhrase.length >= 3) {
          self.criteria.searchPhrase = searchPhrase;
          self.criteria.showInactive = self.showInactive;

          self.loadReportData();
        }
        else if (searchPhrase == "") {
          self.criteria.searchPhrase = searchPhrase;
          self.loadReportData();
        }

      },
      handleChangePage(pageNumber) {
        var self = this;

        if (pageNumber > 0) {
          self.criteria.pageNumber = pageNumber;
          self.criteria.showInactive = self.showInactive;

          self.loadReportData();
        }
      },
      loadReportData() {
        const self = this;
        self.showLoadingOnTable();

        var onSuccess = function (response) {
          self.reports = [];
          if (self.criteria.pageNumber > 1)
            self.reports[((self.criteria.pageNumber - 1) * self.pageSize) - 1] = {};

          self.reports = self.reports.concat(response.data.reports);

          if (response.data.count > (self.criteria.pageNumber * self.pageSize))
            self.reports[response.data.count - 1] = {};
        }

        var onFinally = function () {
          self.$vs.loading.close(self.$refs.reportsTable.$el);
        }

        self.$ajaxPost(self, "Report/List", self.criteria, onSuccess, onFinally);
      },
      showLoadingOnTable() {
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.reportsTable.$el,
          scale: 1
        });
      },
      handleSelectedReport(report) {
        var self = this;
        if(self.$acl.check("Monitor") && self.selectedCompanyId == 0){
          self.$vs.notify({
            title:'Information',
            color: "danger",
            text: "Select a Company",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-alert-circle'
          });
          return
        }
        if(self.$acl.check("Monitor")){
          self.documentUrl=`${report.reportUrl}&SiteId=${self.currentSiteId}&CompanyId=${self.selectedCompanyId}&rs:Embed=True`
        }
        else{
          self.documentUrl= report.reportUrl +'&SiteId='+self.currentSiteId +'&rs:Embed=True'
        }
        window.open(self.documentUrl, "_blank");
      },
      cancelReportViewer() {
        var self = this;

        self.isInfoHidden = true;
        self.loadReportData();
      },
      copy(){
        var self = this;
        const clipboardData = window.clipboardData ||navigator.clipboard;
        var copyText = document.getElementById("CopyText").innerText;
        clipboardData.writeText(copyText);
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Copied",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-save'
        });
      },
      selectedCompany(company){
        var self = this;
        self.selectedCompanyName = company.text;
        self.selectedCompanyId = company.value;
      },
      getCompanyList(){
        var self = this;
        self.showLoadingOnElement("companyListDropDown",1,"corners");
        var onSuccess = response =>{
          self.companyList = response.data;
        }
      
        var onFinally = response =>{
          if(self.$refs.companyListDropDown){
            self.$vs.loading.close(self.$refs.companyListDropDown.$el);
          }
        }
      
        self.$ajaxGet(self, `Monitor/GetCompanyList` , onSuccess, onFinally);
      },
      showLoadingOnElement(element, scale, type) {
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
    },

    mounted() {
      
      var self = this;
      if(self.$acl.check("Monitor")){
        self.getCompanyList();
      }
      self.showLoadingOnTable();
      self.currentSiteId = self.$getSiteId();

      self.criteria.pageSize = self.pageSize;
      self.criteria.pageNumber = self.$refs.reportsTable.currentPage;

      self.loadReportData();
    },
  }

</script>

<style lang="scss">
  .credentials{
    position: relative;
    top: 10px;
    left: 22px;
    font-size: 12px;
    h5{
      font-size: 14px;
    }
  }
  #reportViewerCard{
    height:70vh;
    .vx-card__collapsible-content{
      height: 100%;

      .vx-card__body{
        height: 80% !important;
      }
    }
  }

  div#transactionsPopup.vs-component.con-vs-popup.vs-popup-primary {
    div .vs-popup

  {
    header .vs-popup--header

  {
    i .vs-icon.notranslate.icon-scale.vs-popup--close.vs-popup--close--icon.material-icons.null

  {
    background: rgb(253, 0, 0) !important;
    color: rgb(255, 255, 255);
  }

  }
  }
  }

  #profileimg {
    border-radius: 50%;
    padding: 2px;
    border: 1px solid #838383;
    background-color: rgb(255, 255, 255);
    /* max-width: 100px; */
  }

  .v-select {
    overflow: unset;
  }

  #modulesTable {
    .vs-table--header

  {
    display: flex;
    flex-wrap: wrap-reverse;
    > span

  {
    padding-inline-end: 30px;
    width: calc(100% - 200px);
  }

  }
  }

  #profilerow {
    align-items: center;
  }

  .text {
    border-radius: 50%;
    color: rgb(41, 41, 41);
    font-size: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    text-align: center;
    text-shadow: 2px 2px 5px rgb(255, 255, 255);
  }

  .container:hover .overlay {
    opacity: 1;
    border-radius: 50%;
  }

  .container {
    position: relative;
    width: 50%;
    border-radius: 50%;
  }

  .overlay {
    border-radius: 50%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
    transition: .5s ease;
  }
  .coppyButton{
    z-index: 20;
  }
</style>
